// This file is no longer in use, these events need to be migrated to Tag Manager once we've set it up.

import $ from 'jquery';

const host = window.location.hostname;
const STAGING_TRACKER_ID = 'UA-175051160-2';
const PRODUCTION_TRACKER_ID = 'UA-175051160-1';

const HIT_TYPES = {
  event: 'event'
};

const EVENT_CATEGORIES = {
  contentPartnerPage: 'Content partner page',
  externalLink: 'External link',
  islandPage: 'Island (country) page',
  itemPage: 'Item page',
  locationButton: 'Explore (location) button',
  mediaTypeCard: 'Media type card'
};

const EVENT_ACTIONS = {
  click: 'Click',
  clickWithContentPartner: 'Click with content partner',
  pageView: 'Page view',
  pageViewWithCollection: 'Page view with collection',
  pageViewWithContentPartner: 'Page view with content partner'
};

window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());

if (host.includes('staging.digitalpasifik.org')) {
  gtag('config', STAGING_TRACKER_ID);
} else {
  gtag('config', PRODUCTION_TRACKER_ID);
}

gtag('event', EVENT_ACTIONS.pageView);

$(function () {
  let contentPartners = $('.ga-tracking-data__content-partners');
  if (contentPartners) contentPartners = contentPartners.text().trim().split(', ')

  trackExternalLinkClicks(contentPartners);
  trackExploreMenuButtonClick();

  if (window.location.pathname.match('/')) trackMediaTypeCardClick();
  if (window.location.pathname.match('content_partners')) trackContentPartnerViews();
  if (window.location.pathname.match('islands')) trackIslandPageViews();
  if (window.location.pathname.match('items')) trackItemViews(contentPartners);
});

function trackExternalLinkClicks(contentPartners) {
  const externalLinks = $('.external');

  $(externalLinks).on('click', function (e) {
    trackExternalLinkClick(e);

    if (contentPartners) {
      trackExternalLinkClickWithContentPartner(contentPartners);
    }
  });
}

function trackExploreMenuButtonClick() {
  $('.dropdown-pane-button').on('click', function() {
    gtag(HIT_TYPES.event, EVENT_ACTIONS.click, {
      'event_category': EVENT_CATEGORIES.locationButton,
    });
  });
}

function trackMediaTypeCardClick() {
  const mediaTypeCards = $('.ga-tracking-data__media-type-card');

  $(mediaTypeCards).each(function(_idx, mediaTypeCard) {
    $(mediaTypeCard).on('click', function() {
      gtag(HIT_TYPES.event, EVENT_ACTIONS.click, {
        'event_category': EVENT_CATEGORIES.mediaTypeCard,
        'event_label': $(mediaTypeCard).find('.pvm-card__title').text().trim()
      });
    });
  });
}

function trackContentPartnerViews() {
  gtag(HIT_TYPES.event, EVENT_ACTIONS.pageView, {
    'event_category': EVENT_CATEGORIES.contentPartnerPage,
    'event_label': $('.page-header__title').text().trim()
  });
}

function trackIslandPageViews() {
  gtag(HIT_TYPES.event, EVENT_ACTIONS.pageView, {
    'event_category': EVENT_CATEGORIES.islandPage,
    'event_label': $('.ga-tracking-data__island-name').text().trim()
  });
}

function trackItemViews(contentPartners) {
  const displayCollection = $('.ga-tracking-data__display-collection').text().trim();

  if (displayCollection && contentPartners) {
    trackItemPageViewWithCollection(contentPartners, displayCollection);
  }

  if (contentPartners) {
    contentPartners.forEach(function (contentPartner) {
      trackItemPageViewWithContentPartner(contentPartner);
    });
  }
}

function trackExternalLinkClick(event) {
  gtag(HIT_TYPES.event, EVENT_ACTIONS.click, {
    'event_category': EVENT_CATEGORIES.externalLink,
    'event_label': event.currentTarget.href
  });
}

function trackExternalLinkClickWithContentPartner(partners) {
  gtag(HIT_TYPES.event, EVENT_ACTIONS.clickWithContentPartner, {
    'event_category': EVENT_CATEGORIES.externalLink,
    'event_label': `content_partner: ${partners.join(', ')}`
  });
}

function trackItemPageViewWithContentPartner(partner) {
  gtag(HIT_TYPES.event, EVENT_ACTIONS.pageViewWithContentPartner, {
    'event_category': EVENT_CATEGORIES.itemPage,
    'event_label': `content_partner: ${partner}`
  });
}

function trackItemPageViewWithCollection(partners, collection) {
  const eventLabel = `content_partner: ${partners.join(', ')} | collection: ${collection}`

  gtag(HIT_TYPES.event, EVENT_ACTIONS.pageViewWithCollection, {
    'event_category': EVENT_CATEGORIES.itemPage,
    'event_label': eventLabel
  });
}
